export default {
  BREAKPOINTS: 'CodeMirror-breakpoints',
  LINE_ARROWS: 'CodeMirror-line-arrows', 
  FEEDBACK_NOTES: 'CodeMirror-feedback-notes',
  LINE_NUMBERS: 'CodeMirror-linenumbers',
  FOLD_GUTTER: 'CodeMirror-foldgutter'
};
